import "@/styles/components/site-header.css";

const siteHeader = document.querySelector(".site-header");
const scrollPixel = document.querySelector(".scroll-pixel");

export default {
  init: () => {
    if (siteHeader && scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    const setHeight = () => {
      if (siteHeader) {
        document.documentElement.style.setProperty("--site-header-height", `${Math.ceil(siteHeader.offsetHeight)}px`);
      }
    };

    const resizeObserver = new ResizeObserver(setHeight);
    resizeObserver.observe(document.body);

    setHeight();
  },
};
